import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PROGRAM_COLORS = [
  { bg: "#FEF3C7", accent: "#F5C518" },
  { bg: "#DBEAFE", accent: "#3B82F6" },
  { bg: "#FCE7F3", accent: "#EC4899" },
  { bg: "#D1FAE5", accent: "#10B981" },
];

const PROGRAM_ICON = (
  <svg height="20" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
  </svg>
);

const GLOBE_ICON = (
  <svg height="14" width="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
  </svg>
);

const CourseCard = ({ course, index = 0 }) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleEnroll = () => {
    const price = course.discountedPrice || 0;
    const priceWithGst = (price * 1.18).toFixed(2); // Apply 18% GST
    sessionStorage.setItem('courseName', course.title);
    sessionStorage.setItem('courseFee', priceWithGst);
    sessionStorage.setItem('courseId', course.courseId);
    navigate('/enroll');
  };

  const color = PROGRAM_COLORS[index % PROGRAM_COLORS.length];
  const isOnline = course.category?.toLowerCase().includes("online") || course.id > 2;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <style>{`
        .course-card-padding { padding: 1.25rem; }
        .course-card-title { font-size: 1.125rem; }
        .course-card-title-long { font-size: 0.95rem; line-height: 1.4; }
        .course-card-badge-top { font-size: 9px; }
        .course-card-save-badge { font-size: 10px; }
        .course-card-price { font-size: 1.25rem; }
        .course-card-original-price { font-size: 0.875rem; }
        .course-card-discount-badge { font-size: 10px; }
        @media (min-width: 640px) {
          .course-card-padding { padding: 1.5rem; }
          .course-card-title { font-size: 1.25rem; }
          .course-card-title-long { font-size: 1.05rem; }
          .course-card-badge-top { font-size: 10px; }
          .course-card-save-badge { font-size: 11px; }
        }
        @media (min-width: 1024px) {
          .course-card-price { font-size: 1.875rem !important; }
          .course-card-original-price { font-size: 1rem !important; }
          .course-card-discount-badge { font-size: 12px !important; }
        }
      `}</style>
      {course.courseId && course.courseId.includes("MSI") && (
        <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
          <div className="course-card-badge-top" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            borderTopLeftRadius: '0.75rem',
            borderTopRightRadius: '0.75rem',
            backgroundImage: 'linear-gradient(to right, #ef4444, #e11d48)',
            padding: '0.25rem 0.75rem',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: '#ffffff',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
          }}>
            Free Problem Solving Course Worth ₹4000
          </div>
        </div>
      )}
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          position: 'relative',
          display: 'flex',
          flex: '1 1 0%',
          flexDirection: 'column',
          overflow: 'hidden',
          borderRadius: '1.5rem',
          boxShadow: isHovered ? '0 25px 50px -12px rgba(14,28,72,0.1)' : '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          transition: 'all 0.5s',
          minHeight: '34rem',
        }}
      >
        {course.courseId && course.courseId.includes("MSI") && (
          <div
            className="course-card-save-badge"
            style={{
              position: 'absolute',
              right: '0',
              top: '0',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              gap: '0.25rem',
              borderBottomLeftRadius: '1rem',
              backgroundImage: 'linear-gradient(to right, #22c55e, #059669)',
              padding: '0.375rem 1rem',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              color: 'white',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
              animation: 'bannerPulse 2s ease-in-out infinite',
              transformOrigin: 'top right'
            }}
          >
            <style>{`
            @keyframes bannerPulse {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.08); }
            }
          `}</style>
            <svg height="14" width="14" fill="currentColor" viewBox="0 0 24 24" style={{ color: '#fde047' }}>
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
            Save Extra ₹8000
          </div>
        )}
        <div className="course-card-padding" style={{
          display: 'flex',
          flex: '1 1 0%',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: color.bg,
        }}>
          <div>
            <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
              <div style={{
                display: 'flex',
                height: '3rem',
                width: '3rem',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '1rem',
                backgroundColor: color.accent,
                color: 'white',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
              }}>
                {PROGRAM_ICON}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.5rem' }}>
                {(() => {
                  let badgeText = "Class";
                  if (course.title.includes("10")) badgeText = "Class 10";
                  else if (course.title.includes("9")) badgeText = "Class 9";
                  else if (course.title.includes("8")) badgeText = "Class 8";

                  return (
                    <span style={{
                      borderRadius: '9999px',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      padding: '0.25rem 0.75rem',
                      fontSize: '10px',
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      color: '#0E1C48',
                      backdropFilter: 'blur(4px)'
                    }}>
                      {badgeText}
                    </span>
                  );
                })()}
              </div>
            </div>

            <h3 className={course.title.length > 40 ? "course-card-title-long" : "course-card-title"} style={{ marginBottom: '0.5rem', fontWeight: '700', color: '#0E1C48' }}>
              {course.title}
            </h3>

            <div style={{
              marginTop: '0.5rem',
              borderRadius: '1rem',
              border: '1px solid rgba(14, 28, 72, 0.1)',
              backgroundColor: 'rgba(255, 255, 255, 0.85)',
              padding: '0.75rem'
            }}>
              <ul style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                fontSize: '14px',
                lineHeight: '1.625',
                color: '#334155',
                padding: 0,
                margin: 0,
                listStyle: 'none'
              }}>
                {(course.highlights || []).map((point, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                    <span style={{
                      marginTop: '0.375rem',
                      height: '0.375rem',
                      width: '0.375rem',
                      flexShrink: 0,
                      borderRadius: '9999px',
                      backgroundColor: i === 0 ? '#0E1C48' : 'rgba(14, 28, 72, 0.7)'
                    }} />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div style={{ marginTop: '1rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', marginBottom: '0.75rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                <span className="course-card-price" style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0E1C48' }}>
                  ₹{course.discountedPrice.toLocaleString("en-IN")}
                </span>
                {course.originalPrice > course.discountedPrice && (
                  <>
                    <span className="course-card-original-price" style={{ textDecoration: 'line-through', textDecorationColor: 'rgba(239, 68, 68, 0.5)', textDecorationThickness: '2px', fontSize: '0.875rem', fontWeight: '500', color: '#64748b' }}>
                      ₹{course.originalPrice.toLocaleString("en-IN")}
                    </span>
                    <span className="course-card-discount-badge" style={{
                      marginLeft: '0.25rem',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.25rem',
                      borderRadius: '9999px',
                      backgroundImage: 'linear-gradient(to right, #22c55e, #059669)',
                      padding: '0.125rem 0.625rem',
                      fontSize: '10px',
                      fontWeight: '900',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      color: 'white',
                      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 4px 6px -1px rgba(34, 197, 94, 0.3)',
                      border: '1px solid rgba(74, 222, 128, 0.5)'
                    }}>
                      <svg style={{ height: '0.75rem', width: '0.75rem', color: '#dcfce7' }} fill="currentColor" viewBox="0 0 24 24">
                        <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.41l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.36-.36.59-.86.59-1.41s-.23-1.06-.59-1.41zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
                      </svg>
                      {Math.round(((course.originalPrice - course.discountedPrice) / course.originalPrice) * 100)}% OFF
                    </span>
                  </>
                )}
              </div>
              <small style={{ fontSize: '10px', color: '#64748b' }}>+18% GST applicable on final amount</small>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <a
                href={course.courseId ? `https://educatory.ac/planner/${course.courseId}` : "#"}
                target="_blank"
                rel="noreferrer"
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(14, 28, 72, 0.2)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)'; }}
                style={{
                  display: 'inline-flex',
                  height: '2.25rem',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  borderRadius: '9999px',
                  backgroundColor: '#0E1C48',
                  fontSize: '11px',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  color: 'white',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  transition: 'all 0.3s',
                  textDecoration: 'none',
                  cursor: 'pointer'
                }}
              >
                <svg height="16" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                View Course Planner
              </a>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                <button
                  onClick={handleEnroll}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.02)'; e.currentTarget.style.backgroundColor = '#ffffff'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)'; }}
                  style={{
                    display: 'inline-flex',
                    height: '2.25rem',
                    minWidth: 0,
                    flex: '1 1 0%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '9999px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    paddingLeft: '0.75rem',
                    paddingRight: '0.75rem',
                    fontSize: '12px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    color: '#0E1C48',
                    backdropFilter: 'blur(12px)',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                >
                  Enroll
                </button>
                <a
                  href="https://courses.educatory.ac"
                  target="_blank"
                  rel="noreferrer"
                  onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.02)'; e.currentTarget.style.backgroundColor = '#ffffff'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)'; }}
                  style={{
                    display: 'inline-flex',
                    height: '2.25rem',
                    minWidth: 0,
                    flex: '1 1 0%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '9999px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    paddingLeft: '0.75rem',
                    paddingRight: '0.75rem',
                    fontSize: '12px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    color: '#0E1C48',
                    backdropFilter: 'blur(12px)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                >
                  Login
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;